import React from 'react';
import { useLocation } from 'react-router';
import { Link } from 'react-router-dom';

const Dashboard = () => {
  const location = useLocation();

  const { pathname } = location;
  const pathnames = pathname.split('/');
  const page = pathnames[2];

  return (
    <>
      <aside id="sidebar" className="sidebar">
        <ul className="sidebar-nav" id="sidebar-nav">
          <li className="nav-item">
            <Link 
              to="/admin/home"
              className={`nav-link ${page==='home' ? '' : 'collapsed'}`}
            >
              <i className="fas fa-home"></i>
              <span>Home</span>
            </Link>
          </li>
          <li className="nav-item">
            <Link 
              to="/admin/akun"
              className={`nav-link ${page==='akun' ? '' : 'collapsed'}`}
            >
              <i className="fas fa-user-cog"></i>
              <span>Akun</span>
            </Link>
          </li>
          <li className="nav-item">
            <Link 
              to="/admin/grafik"
              className={`nav-link ${page==='grafik' ? '' : 'collapsed'}`}
            >
              <i className="fas fa-chart-line"></i>
              <span>Grafik</span>
            </Link>
          </li>
          <li className="nav-item">
            <Link 
              to="/admin/riwayat"
              className={`nav-link ${page==='riwayat' ? '' : 'collapsed'}`}
            >
              <i className="fas fa-history"></i>
              <span>Riwayat</span>
            </Link>
          </li>
          <li className="nav-item">
            <Link 
              to="/admin/user"
              className={`nav-link ${page==='user' ? '' : 'collapsed'}`}
            >
              <i className="fas fa-users"></i>
              <span>User</span>
            </Link>
          </li>
          <li className="nav-item">
            <Link 
              to="/admin/lokasi"
              className={`nav-link ${page==='lokasi' ? '' : 'collapsed'}`}
            >
              <i className="fas fa-map"></i>
              <span>Lokasi</span>
            </Link>
          </li>
        </ul>
      </aside>
    </>
  );
};

export default Dashboard;
